import React, { Component } from 'react';
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import store, {persistor, history} from "./store/store";
import InitialRouter from './components/routers/initialRouter';
import {PersistGate} from "redux-persist/es/integration/react";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Colors from './helpers/colors';
import './styles/general.css'
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

const theme = createMuiTheme({
  palette: {
    primary: { main: Colors.COFFEE_ISLAND_YELLOW },
    secondary: { main: Colors.COFFEE_BROWN },
  },
});


class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <MuiThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <InitialRouter/>
              </MuiPickersUtilsProvider>
            </MuiThemeProvider>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js